import React from 'react';
import { IconProps } from '../types/types';

const USDSILVER: React.FC<IconProps> = (props) => (
    <svg viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path d="M13.656 26.193c7.194 0 13.026-5.832 13.026-13.026C26.682 5.975 20.85.143 13.656.143 6.463.142.631 5.974.631 13.168c0 7.193 5.832 13.025 13.025 13.025Z" fill="#F0F0F0" />
        <path
            d="M13.094 13.167h13.592a13.04 13.04 0 0 0-.45-3.398H13.095v3.398ZM13.094 6.371h11.68a13.095 13.095 0 0 0-3.006-3.398h-8.674v3.398ZM13.659 26.192a12.97 12.97 0 0 0 8.108-2.831H5.551a12.97 12.97 0 0 0 8.108 2.831ZM2.547 19.963h22.227a12.95 12.95 0 0 0 1.463-3.398H1.084a12.949 12.949 0 0 0 1.463 3.398Z"
            fill="#D80027"
        />
        <path
            d="M6.664 2.176h1.187l-1.104.802.422 1.298-1.104-.802-1.104.802.364-1.121A13.097 13.097 0 0 0 2.8 5.971h.38l-.702.51c-.11.183-.215.368-.316.557l.336 1.033-.626-.455a12.9 12.9 0 0 0-.426 1.01l.37 1.139h1.364l-1.104.802.422 1.298-1.104-.802-.661.48a13.15 13.15 0 0 0-.101 1.625h13.025V.142c-2.573 0-4.972.747-6.992 2.034Zm.505 9.689-1.104-.802-1.104.802.422-1.298-1.104-.802h1.364l.422-1.298.422 1.298H7.85l-1.104.802.422 1.298Zm-.422-5.092L7.17 8.07l-1.104-.803-1.104.803.422-1.298-1.104-.802h1.364l.422-1.298.422 1.298H7.85l-1.104.802Zm5.094 5.092-1.104-.802-1.104.802.422-1.298-1.104-.802h1.364l.422-1.298.422 1.298h1.365l-1.104.802.421 1.298Zm-.421-5.092.421 1.298-1.104-.803-1.104.803.422-1.298L8.95 5.97h1.364l.422-1.298.422 1.298h1.365l-1.104.802Zm0-3.795.421 1.298-1.104-.802-1.104.802.422-1.298-1.104-.802h1.364l.422-1.298.422 1.298h1.365l-1.104.802Z"
            fill="#0052B4"
        />
        <path
            d="M25.645 39.961c7.331 0 13.275-5.944 13.275-13.275 0-7.332-5.944-13.276-13.275-13.276-7.332 0-13.276 5.944-13.276 13.276 0 7.331 5.944 13.275 13.276 13.275Z"
            fill="#B3B3B3"
            stroke="#fff"
            strokeWidth={0.5}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.814 20.743a.241.241 0 0 0-.234.182l-1.036 4.065h8.2l-1.053-4.066a.241.241 0 0 0-.234-.18h-5.643Zm-.701.063a.724.724 0 0 1 .701-.546h5.643c.33 0 .619.224.701.543l1.054 4.066a.483.483 0 0 1-.467.604h-8.201a.483.483 0 0 1-.468-.602l1.037-4.065Z"
            fill="#fff"
            stroke="#fff"
            strokeWidth={0.25}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.4 25.776a.241.241 0 0 0-.234.182l-1.036 4.064h8.2l-1.053-4.065a.241.241 0 0 0-.234-.181H18.4Zm-.701.062a.724.724 0 0 1 .701-.545h5.643c.33 0 .619.223.701.543l1.054 4.065a.483.483 0 0 1-.467.604H17.13a.483.483 0 0 1-.468-.602l1.037-4.065Z"
            fill="#fff"
            stroke="#fff"
            strokeWidth={0.25}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M27.225 25.776a.241.241 0 0 0-.234.182l-1.037 4.064h8.2l-1.053-4.065a.241.241 0 0 0-.233-.181h-5.643Zm-.702.062a.724.724 0 0 1 .702-.545h5.642c.33 0 .619.223.702.543l1.053 4.065a.483.483 0 0 1-.467.604h-8.201a.483.483 0 0 1-.468-.602l1.037-4.065Z"
            fill="#fff"
            stroke="#fff"
            strokeWidth={0.25}
        />
    </svg>
);

export default USDSILVER;
